export class BalanceEntity {
    balanceId: string
    companyId: string
    byCompanyId: string
    date: string | Date
    label: string
    value: number
    type: BALANCE_TYPE
    service: SERVICE
}

export class BalanceAllEntity {
    companyId: string
    balance: { service: string; balance: number }[]
}

export enum BALANCE_TYPE {
    CONSUMED = 'consumed',
    CREDIT = 'credit',
    DEBIT = 'debit',
}

export enum SERVICE {
    CALL = 'call',
    EMAIL = 'email',
    EVO = 'evo',
    PUSH = 'push',
    SMS = 'sms',
    WA = 'wa',
    WABA = 'waba',
}
